import { Profession } from '@common/enums';
/*
 * This module is a temporary solution until there is central authorization solution.
 * In the future it would be nice to set up a user/employments authorization API in combination with state management.
 */
import { getProcessAuthorizations } from './api/processesApiService';

export function hasBrightPlanAccess(profession: Profession, brightPlanIntegrationEnabled: boolean): boolean {
    return (
        brightPlanIntegrationEnabled &&
        [Profession.bariNurse, Profession.osasNurse, Profession.outpatientAssistant].includes(profession)
    );
}

export async function canReadBariPostTotalWeightLoss(processId: string, signal: AbortSignal): Promise<boolean> {
    const authorizations = await getProcessAuthorizations(processId, signal);

    return Boolean(authorizations.serviceAuthorizations?.BariPost?.canReadTotalWeightLoss);
}

export async function canReadBariPostQuestionnaireResponses(processId: string, signal: AbortSignal): Promise<boolean> {
    const authorizations = await getProcessAuthorizations(processId, signal);

    return Boolean(authorizations.serviceAuthorizations?.BariPost?.canReadQuestionnaireResponses);
}
